/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { ChartProps, SdgChart } from './SdgChart';
import './SdgChartModal.scss'

interface SdgChartModalProps extends ChartProps {
  isOpen: boolean
  toggle: () => any;
  headerTitle?: string;
}

// Only Works in XL screen
export const SdgChartModal = (props: SdgChartModalProps) => {
  const {
    isOpen,
    toggle,
    headerTitle = 'SDG Contribution',
    ...chartProps
  } = props;

  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop='static' className='sdg-chart-modal-container'>
      <ModalHeader toggle={toggle}>{headerTitle}</ModalHeader>
      <ModalBody>
        <SdgChart {...chartProps} />
      </ModalBody>
    </Modal>
  );
}
